var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "crearGeneralSolicitudBajaClientes",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c(
        "div",
        { attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-form",
                {
                  model: {
                    value: _vm.dialog,
                    callback: function($$v) {
                      _vm.dialog = $$v
                    },
                    expression: "dialog"
                  }
                },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "div",
                        { attrs: { align: "left" } },
                        [
                          _c("v-flex", [
                            _c(
                              "h2",
                              {
                                staticClass: "h2_title",
                                staticStyle: { "margin-top": "12px !important" }
                              },
                              [
                                _vm._v(
                                  "\n                Datos Generales\n              "
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c("br"),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.numero.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.numero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.numero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.numero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.fechaCreacion.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.fechaCreacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaCreacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaCreacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.usuarioCreacion.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.usuarioCreacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.usuarioCreacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.usuarioCreacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  label: _vm.formFields.motivoTipo.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.motivoTipo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.motivoTipo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.motivoTipo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.observacion.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.observacion.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.observacion,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.observacion.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.tramo.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.tramo.value,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formFields.tramo, "value", $$v)
                                  },
                                  expression: "formFields.tramo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.cantidadClientes.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.cantidadClientes.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadClientes,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidadClientes.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.cantidadEquipos.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.cantidadEquipos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadEquipos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.cantidadEquipos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label:
                                    _vm.formFields.cantidadPerifericos.label,
                                  disabled: true
                                },
                                model: {
                                  value:
                                    _vm.formFields.cantidadPerifericos.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadPerifericos,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidadPerifericos.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.estado.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.estado.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.estado,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.estado.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.fechaEjecuta.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.fechaEjecuta.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.fechaEjecuta,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.fechaEjecuta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.usuarioEjecuta.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.usuarioEjecuta.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.usuarioEjecuta,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.usuarioEjecuta.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label: _vm.formFields.cantidadSimCards.label,
                                  disabled: true
                                },
                                model: {
                                  value: _vm.formFields.cantidadSimCards.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadSimCards,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidadSimCards.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mr-2",
                                attrs: {
                                  name: "movimiento",
                                  label:
                                    _vm.formFields.cantidadEquiposConfirmados
                                      .label,
                                  disabled: true
                                },
                                model: {
                                  value:
                                    _vm.formFields.cantidadEquiposConfirmados
                                      .value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.cantidadEquiposConfirmados,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.cantidadEquiposConfirmados.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }